import { CardDivider, InfoRow, NormalText } from "@components/styles/dataDisplay";
import { LawsuitInfo } from "@customTypes/responses/lawsuit";
import React from "react";
import { Tooltip } from "nectar-ui";
import { CustomLink } from "@pages/LawsuitPage/style";
import { useHistory } from "react-router-dom";
import { ATTACHMENT_TEXT } from "./attachmentConstants";

type LawsuitAttachmentProps = {
  attachments: LawsuitInfo["attachments"];
  lawsuitId: number;
};

const LawsuitAttachments: React.FC<LawsuitAttachmentProps> = ({ attachments, lawsuitId }) => {
  const history = useHistory();

  const handleLinkClick = (id: number) => () => {
    history.replace(`${id}`);
  };

  const visibleAttachments = attachments.filter(
    (attachment) => attachment.canSee && attachment.id !== lawsuitId
  );

  const unauthorizedAttachments = attachments.filter(
    (attachment) => !attachment.canSee && attachment.id !== lawsuitId
  );

  const unauthorizedAttachmentCount = unauthorizedAttachments?.length;

  const shouldShowAttachments = visibleAttachments.length > 0 || unauthorizedAttachments.length > 0;

  const { inLimit, passedLimit } = ATTACHMENT_TEXT.unathorizedLimit;

  return (
    <>
      {shouldShowAttachments && (
        <>
          <CardDivider />
          <InfoRow key={lawsuitId}>
            <NormalText semiBold color="gray">
              Apenso
            </NormalText>

            <div style={{ display: "flex", flexDirection: "column", rowGap: 16 }}>
              {visibleAttachments.map((attachment) => (
                <Tooltip
                  title="Visualizar"
                  isVisible
                  placement="top"
                  key={attachment.id}
                  preventOverflow
                >
                  <CustomLink to="" onClick={handleLinkClick(attachment.id)}>
                    {attachment.title}
                  </CustomLink>
                </Tooltip>
              ))}
              {unauthorizedAttachments.length > 0 && (
                <div style={{ display: "flex", flexDirection: "column", rowGap: 8 }}>
                  <NormalText>
                    {unauthorizedAttachmentCount >= 2 ? passedLimit.text : inLimit.text}
                  </NormalText>
                  <NormalText color="gray">
                    {unauthorizedAttachmentCount >= 2 ? passedLimit.subtext : inLimit.subtext}
                  </NormalText>
                </div>
              )}
            </div>
          </InfoRow>
        </>
      )}
    </>
  );
};
export default LawsuitAttachments;
